import { ChildrenProps } from '../types';

const DefaultLayoutLogin = ({ children }: ChildrenProps) => {
  return <div className="wrapper-login">{children}</div>;
};

export default DefaultLayoutLogin;
